import { Part, ReplacementCartItem } from "features/reducers/replacementOrder/cart.ts";
import { QuantityText } from "constants/text.ts";
import {
	SelectReplacementReasonDropdowns,
	SelectReplacementReasonPartInfo,
	SelectReplacementReasonPartInfoQty,
	SelectReplacementReasonPartInfoSku,
	SelectReplacementReasonReview,
	SelectReplacementReasonWrapper
} from "components/Replacements/SelectReplacementReason.styles.ts";
import SelectReplacementReasonAndProblemDropdowns from "components/Replacements/components/SelectReplacementReasonAndProblemDropdowns/SelectReplacementReasonAndProblemDropdowns.tsx";

interface SelectReplacementReasonProps {
	item: ReplacementCartItem;
	part?: Part;
	fieldPrefix: string;
	reasonReview?: string;
	uploadedImages?: string[];
	comment?: string | null;
}

const SelectReplacementReason = ({
	item,
	part,
	fieldPrefix,
	reasonReview,
	uploadedImages,
	comment
}: SelectReplacementReasonProps) => {
	const sku = part?.partSku ?? item.sku;
	const description = part?.description ?? item.description;
	const quantity = part?.partQuantity ?? item.wholeCabinetQuantity;
	const getContainerTestId = () => {
		if (reasonReview && part) return "reviewReplacementReason-replace-part-sku";
		if (!reasonReview) return "selectReplacementReason-partSku";
		return undefined;
	};

	const containerTestId = getContainerTestId();
	const descriptionTestId = reasonReview && part ? "reviewReplacementReason-replace-part-description" : undefined;
	return (
		<SelectReplacementReasonWrapper>
			<SelectReplacementReasonPartInfo>
				<div>
					<SelectReplacementReasonPartInfoSku data-testid={containerTestId}>
						<span>{sku}</span>
						<span data-testid={descriptionTestId}>{description}</span>
					</SelectReplacementReasonPartInfoSku>
					<SelectReplacementReasonPartInfoQty data-testid="selectReplacementReason-partQuantityTitle">
						<span>{QuantityText}</span>
						<span>{quantity}</span>
					</SelectReplacementReasonPartInfoQty>
				</div>
			</SelectReplacementReasonPartInfo>
			{reasonReview ? (
				<SelectReplacementReasonReview>
					<SelectReplacementReasonPartInfoQty data-testid="replacementReason-review">
						<span>Replacement Reason</span>
						<span>{reasonReview}</span>
					</SelectReplacementReasonPartInfoQty>
					{!!(uploadedImages?.length && uploadedImages.length > 0) && (
						<SelectReplacementReasonPartInfoQty>
							<span>Uploaded Images</span>
							{uploadedImages.map((image) => (
								<span
									key={image}
									data-testid="reviewReplacementReason-replacement-reason-part-image-name"
								>
									{image}
								</span>
							))}
						</SelectReplacementReasonPartInfoQty>
					)}
					{!!comment && (
						<SelectReplacementReasonPartInfoQty data-testid="replacementComment-review">
							<span>Comment</span>
							<span>{comment}</span>
						</SelectReplacementReasonPartInfoQty>
					)}
				</SelectReplacementReasonReview>
			) : (
				<SelectReplacementReasonDropdowns
					data-testid={`replacementReason-selectReplacementReasonsDropdownContainer-${part?.partSku ?? item.sku}`}
				>
					{!part && item.wholeCabinetQuantity > 0 && (
						<SelectReplacementReasonAndProblemDropdowns
							item={item}
							fieldPrefix={fieldPrefix}
						/>
					)}
					{part && part.partQuantity > 0 && (
						<SelectReplacementReasonAndProblemDropdowns
							item={item}
							part={part}
							fieldPrefix={fieldPrefix}
						/>
					)}
				</SelectReplacementReasonDropdowns>
			)}
		</SelectReplacementReasonWrapper>
	);
};
export default SelectReplacementReason;
